import useCache from '../hooks/use-cache';
import { useGetCategoriesQuery } from '../store';

function useCategories() {

    const cacheKey = 'categories';
    const { data } = useCache(cacheKey, useGetCategoriesQuery);

    let categories = {};

    if (data) {
        categories = data;
    }

    return categories;
}
export default useCategories;